export const HASURA_ROLE_HEADER = 'x-hasura-role';
